// GETTERS
export const GET_APPOINTMENT = 'appointment/GET_APPOINTMENT';
export const GET_APPOINTMENT_LIST = 'appointment/GET_APPOINTMENT_LIST';


// MUTATORS
export const MUTATE_LIST_APPOINTMENT = 'appointment/MUTATE_LIST_APPOINTMENT';


// ACTIONS
export const ACTION_LIST_APPOINTMENTS = 'appointment/ACTION_LIST_APPOINTMENTS';
export const ACTION_ADD = 'appointment/ACTION_ADD';
export const ACTION_DELETE = 'appointment/ACTION_DELETE';
export const ACTION_UPDATE = 'appointment/ACTION_UPDATE';
export const ACTION_GET_APPOINTMENT = 'appointment/ACTION_GET_APPOINTMENT';
export const ACTION_TREND = 'appointment/ACTION_TREND';
export const ACTION_AGGREGATE = 'appointment/ACTION_AGGREGATE';



// WEBPACK FOOTER //
// ./src/store/constants/appointment.js